import { Currencies } from "@orbital/games-frontend-library"

export function cashoutResponceHelper(e, handleNotification) {
  handleNotification(
    `You have cashed out ${e.coeff}x. You won ${e.win}${Currencies[e.currency]
    }`,
  )
}
